import * as React from 'react';

function IconMenu(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.118 6.2h16a1.2 1.2 0 000-2.4h-16a1.2 1.2 0 000 2.4zm16 4.6h-16a1.2 1.2 0 000 2.4h16a1.2 1.2 0 100-2.4zm0 7h-16a1.2 1.2 0 000 2.4h16a1.2 1.2 0 000-2.4z"
        fill="#fff"
      />
    </svg>
  );
}

const MemoIconMenu = React.memo(IconMenu);
export default MemoIconMenu;
